// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber2 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M15.294 15.53H10.87c.49-.392 1.344-1.092 1.974-1.624 1.288-1.092 2.45-2.394 2.45-4.046 0-1.764-1.246-3.052-3.318-3.052-2.198 0-3.36 1.526-3.374 3.36l1.722.07c.014-1.12.518-1.918 1.652-1.918.966 0 1.554.658 1.554 1.582 0 1.078-.546 1.694-1.904 2.996a106 106 0 01-2.94 2.716V17h6.608z" />
  );
export default SvgIconNumber2;
